export default [
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 0,
    "activity": 0,
    "name": "Test diagnostique",
    "student_objective": "Identifier les besoins et orienter vers le parcours pertinent.",
    "teacher_objective": "Identifier les besoins et orienter vers le parcours pertinent.",
    "inspirations": "",
    "sources": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 1,
    "name": "Constitution de groupes de mots à l’intérieur des groupes nominaux",
    "student_objective": "Percevoir que le sens d’un groupe nominal est lié à la façon dont on le décompose.",
    "teacher_objective": "Faire comprendre intuitivement à l’élève que le sens d’un groupe nominal est lié à la façon dont on le décompose.",
    "inspirations": "",
    "sources": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 2,
    "name": "Constitution de groupes de mots et pronominalisation",
    "student_objective": "Former intuitivement des groupes de mots bien constitués, grâce à leur remplacement par des pronoms.",
    "teacher_objective": "Donner à l’élève l’intuition de groupes bien formés (notion de constituance) par la pronominalisation, puisque seuls des constituants bien formés peuvent être pronominalisés.",
    "inspirations": "",
    "sources": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 3,
    "name": "Constitution de groupes et structures de mise en relief  (« c’est … qui/que »)",
    "student_objective": "Former intuitivement des groupes de mots bien constitués, en manipulant la structure « c’est … qui ». ",
    "teacher_objective": "Donner à l’élève l’intuition de groupes bien formés (notion de constituance) par la manipulation de structures de mise en relief (« c’est … qui/que »), puisque seuls des constituants bien formés peuvent être extraits dans une structure de ce type ; donner une idée de la notion d’extraction.",
    "inspirations": "",
    "sources": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 4,
    "name": "Structure des groupes nominaux",
    "student_objective": "Comprendre qu’un groupe nominal n’est pas seulement une suite de mots et qu’il relève d’une organisation structurée.",
    "teacher_objective": "Faire sentir à l’élève qu’un groupe nominal n’est pas seulement une suite de mots et qu’il relève d’une structure identifiable.",
    "inspirations": "",
    "sources": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 1,
    "activity": 5,
    "name": "Constitution de groupes et interrogatives",
    "student_objective": "Former intuitivement des groupes de mots bien constitués, en transformant des phrases en questions.",
    "teacher_objective": "Amener à une réorganisation interne de la phrase pour parvenir à la forme interrogative, de manière à donner une intuition de la notion de constituant.",
    "inspirations": "",
    "sources": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 1,
    "name": "Hiérarchies syntaxiques dans le groupe nominal",
    "student_objective": "Sentir que, dans tout groupe de mots, un mot joue le rôle central.",
    "teacher_objective": "Permettre l’identification intuitive du mot noyau d’un groupe (notion de « tête » ou de « régisseur »), par le biais de son influence en termes de traits morphosyntaxiques sur les autres mots du groupe (notion de « dépendants »).",
    "inspirations": "",
    "sources": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 2,
    "name": "Hiérarchies syntaxiques dans la phrase",
    "student_objective": "Comprendre intuitivement quels sont les éléments essentiels dans une phrase.",
    "teacher_objective": "Faire distinguer les éléments obligatoires des éléments facultatifs, en incitant l’élève à retrouver intuitivement la phrase minimale (sans que ce terme soit utilisé).",
    "inspirations": "",
    "sources": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 3,
    "name": "Relations de dépendance entre les groupes de mots et pronominalisation",
    "student_objective": "Comprendre intuitivement le rôle d’un groupe de mots dans la phrase, grâce au choix d’un pronom capable de le remplacer.",
    "teacher_objective": "Améliorer la perception des relations de dépendance entre groupes, grâce à la pronominalisation, le choix du pronom pour un groupe donné dépendant essentiellement de sa relation aux autres groupes (notion de fonction).",
    "inspirations": "",
    "sources": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 4,
    "name": "Identification intuitive du couple sujet-verbe",
    "student_objective": "Dans une phrase complexe, savoir isoler intuitivement le couple sujet-verbe.",
    "teacher_objective": "Permettre à l’élève de comprendre la structure globale de la phrase, pour distinguer intuitivement le couple sujet-verbe des autres constituants de la phrase.",
    "inspirations": "",
    "sources": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 2,
    "activity": 5,
    "name": "Pronominalisation de catégories différentes",
    "student_objective": "Comprendre que, pour un même contenu, plusieurs choix de construction sont possibles.",
    "teacher_objective": "Appréhender la nature (complétive, infinitive, groupe nominal, groupe prépositionnel…) de groupes en fonction de complément, par le biais du choix du pronom qui dépend en partie de cette nature. Cela permet d’insister sur les choix expressifs possibles pour un même contenu, et sur la façon dont les pronoms peuvent servir d’indice pour identifier les arguments des verbes.",
    "inspirations": "",
    "sources": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 1,
    "name": "Ambiguïté de nature grammaticale pour certains mots",
    "student_objective": "Prendre conscience de l’ambiguïté de très nombreuses formes et s’appuyer sur le contexte pour lever cette ambiguïté.",
    "teacher_objective": "Faire prendre conscience de l’ambiguïté morphologique de très nombreuses formes, et du fait que le contexte lève presque toujours cette ambiguïté.",
    "inspirations": "",
    "sources": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 2,
    "name": "Ambiguïté structurelle",
    "student_objective": "Prendre conscience que de nombreuses structures de phrase sont ambiguës.",
    "teacher_objective": "Faire examiner systématiquement des découpages structurels, pour mettre en évidence l’ambiguïté de certaines structures de phrase.",
    "inspirations": "",
    "sources": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 3,
    "name": "Ambiguïté d’une phrase et nature grammaticale des mots",
    "student_objective": "Prendre conscience que le sens d’une phrase est lié à des choix grammaticaux intuitifs du locuteur.",
    "teacher_objective": "Faire prendre conscience que le sens d’une phrase n’est pas seulement lié à des choix sémantiques, mais également à des choix grammaticaux intuitifs du locuteur.",
    "inspirations": "",
    "sources": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 4,
    "name": "Identification des sources d’ambiguïté ",
    "student_objective": "Analyser l’origine d’une ambiguïté.",
    "teacher_objective": "Analyser l’origine d’une ambiguïté.",
    "inspirations": "",
    "sources": ""
  },
  {
    "subject": "french",
    "grade": 11,
    "module": 1,
    "path": 3,
    "activity": 5,
    "name": "Rôle des mots fonctionnels dans l’analyse structurelle des phrases",
    "student_objective": "Prendre conscience que des mots grammaticaux peu porteurs de sens sont déterminants pour l’analyse intuitive de la phrase, et donc pour son interprétation.",
    "teacher_objective": "Faire prendre conscience de l’importance des mots grammaticaux (fonctionnels) peu porteurs de sens mais déterminants pour l’analyse structurelle d’une phrase.",
    "inspirations": "",
    "sources": ""
  }
 ];